import { Stack } from "@mui/material";
import { SummaryData } from "./SummaryData";
import { WhiteBox } from "@foodpilot/foods";
import { ProductScoreChartColumn } from "../ProductScoreChartColumn";

export const Summary = () => {
    return (
        <WhiteBox gap={4} px={4} py={3.5} sx={{ backgroundColor: "white" }} borderRadius={4}>
            <Stack gap={3} direction="row" justifyContent="space-between">
                <Stack flex={5} gap={3}>
                    <SummaryData />
                </Stack>
                <ProductScoreChartColumn dimension="components" />
            </Stack>
        </WhiteBox>
    );
};
